import { Injectable, QueryList, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { environment } from 'environments/environment';
import { NgDynamicBreadcrumbService } from 'ng-dynamic-breadcrumb';
import { BehaviorSubject } from 'rxjs';
import { Location } from '@angular/common';
import { paymentType } from '@pages/inventory/purchase/table.definition';
interface objProps {
  [key: string]: string;
}

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  public imgBaseUrl = environment.imgBaseUrl;
  public env = environment.forntend_url;
  constructor(
    private breadcrumbService: NgDynamicBreadcrumbService,
    private activatedRoute: ActivatedRoute,
    private _location: Location
  ) {}

  public paginateBtnHtmlChanger() {
    $('.paginate_button.previous')
      .addClass('auction-dataTable-prev')
      .html('<i class="las la-angle-left ion-lg"></i>');

    $('.paginate_button.next')
      .addClass('auction-dataTable-next')
      .html('<i class="las la-angle-right ion-lg"></i>');
  }

  public dtSearch(ev: Event, dtInstances: QueryList<DataTableDirective>) {
    dtInstances.forEach((dtElement: DataTableDirective, index: number) => {
      dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.search(ev.target['value']).draw();
      });
    });
  }

  public dtButtonsManager(collectionMenuBtnClass: string, renderer: Renderer2) {
    const collectionBtn: HTMLButtonElement[] = Array.from(
      document.querySelectorAll('.buttons-collection')
    );
    renderer.addClass(document.querySelector('.dt-buttons'), 'btn-group');
    renderer.removeClass(document.querySelector('.dt-button'), 'dt-button');

    collectionBtn.forEach((btn: HTMLButtonElement, idx: number) => {
      btn.onclick = () => {
        setTimeout(() => {
          const menu: HTMLDivElement = document.querySelector(
            '.dt-button-collection'
          );
          const menuBtns: HTMLButtonElement[] = Array.from(
            menu.querySelectorAll('.dt-button')
          );

          menuBtns.forEach((el: HTMLButtonElement, index: number) => {
            renderer.removeClass(el, 'dt-button');
            el.classList.add('btn', collectionMenuBtnClass, 'w-100');

            if (index !== menuBtns.length - 1) renderer.addClass(el, 'mb-2');
          });
        }, 0);
      };
    });
  }

  public getUnique(arr: any[], comp: string) {
    return arr
      .map((e: any) => e[comp])
      .map((e: any, i: number, final: any[]) => final.indexOf(e) === i && i) // store the keys of the unique objects
      .filter((e: any) => arr[e])
      .map((e: any) => arr[e]); // eliminate the dead keys & store unique objects
  }

  public getStrgObj(data: any[], value: string = 'option'): string {
    let obj: objProps = {};
    data.map((item, index) => {
      return (obj = {
        ...obj,
        [index]: item[value],
      });
    });
    return JSON.stringify(obj);
  }

  InventoryName = (data: Record<any, any>): string => {
    return `${data?.['Model Year']} ${data?.['Model']} ${data?.['Interior Colour']}`;
  };

  modifiedData(productList: object[]): object[] {
    productList.forEach((product: object, index: number) => {
      let frontImg = '';
      let vehicleName = `${product?.['description_data']?.['Model Year']} ${product?.['description_data']?.['Make']} ${product?.['description_data']?.['Model']} ${product?.['description_data']?.['Interior Colour']}`;

      if (
        product?.['vehicle_images']?.['parts_images'] &&
        product['vehicle_images']['parts_images'].length
      ) {
        for (
          let i = 0;
          i < product['vehicle_images']['parts_images'].length;
          i++
        ) {
          if (
            product['vehicle_images']['parts_images'][i]?.['part_name'] ===
            'Front'
          ) {
            frontImg =
              this.imgBaseUrl +
              product['vehicle_images']['parts_images'][i]['image'];
            break;
          }
        }
      } else if (product?.['productImageUrl']?.[0]?.['presigned_url']) {
        frontImg = product['productImageUrl'][0]['presigned_url'];
      } else if (product?.['imageUrl']?.[0]?.['presigned_url']) {
        frontImg = product['imageUrl'][0]['presigned_url'];
      } else {
        frontImg = this.env + 'assets/img/car-placeholder.png';
      }

      if (product['description_data']) {
        product['description_data']['Entity Type'] = product['entity_type'];
      }

      productList[index]['frontImg'] = frontImg;
      productList[index]['vehicleName'] = vehicleName;

      // To delete some key from object
      for (let property in product['description_data']) {
        if (product['description_data'].hasOwnProperty('vehicle_360_link')) {
          delete product['description_data']['vehicle_360_link'];
        }
        if (product['description_data'].hasOwnProperty('Vehicle 360 link')) {
          delete product['description_data']['Vehicle 360 link'];
        }
        if (product['description_data'].hasOwnProperty('description')) {
          delete product['description_data']['description'];
        }
        if (product['description_data'].hasOwnProperty('test_drive_video')) {
          delete product['description_data']['test_drive_video'];
        }
        if (product['description_data'].hasOwnProperty('Test Drive Video')) {
          delete product['description_data']['Test Drive Video'];
        }
        if (product['description_data'].hasOwnProperty('Description')) {
          delete product['description_data']['Description'];
        }
      }
    });

    return productList;
  }

  public isLoading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  goBack() {
    this._location.back();
  }

  prepareRetailAndNewTableData(
    vehicles: object[],
    vehicleType: 'used' | 'new' | 'inventory-new'
  ) {
    const imageUrl =
      vehicleType === 'used' || vehicleType === 'inventory-new'
        ? environment.auctionBaseUrl
        : environment.imgBaseUrl;

    const preparedData = vehicles.map((vehicle) => {
      return {
        Photo: vehicle['vehicle_images']?.['parts_images']?.length
          ? imageUrl +
            vehicle['vehicle_images']?.['parts_images'].filter(
              (part) => part.part_name === 'Front'
            )?.[0]['image']
          : environment.forntend_url + 'assets/img/car-placeholder.png',
        Status: vehicle['active'] ? 'Active' : 'Inactive',
        Make: vehicle['description_data']['Make'],
        Model: vehicle['description_data']['Model'],
        'Trim/Type': vehicle['description_data']['Trim/Type'],
        'Model Year': vehicle['description_data']['Model Year'],
        VIN: vehicle['description_data']['VIN Number'],
        Registration: vehicle['description_data']['Plate Number'],
        ODO: vehicle['description_data']['ODO'],
        'Exterior Colour': vehicle['description_data']['Exterior Colour'],
        'Interior Colour': vehicle['description_data']['Interior Colour'],
        'Engine CC': vehicle['description_data']['CC'],
        Gears: vehicle['description_data']?.['Gear'] || '--',
        Accleration: vehicle['description_data']?.['Accleration'] || '--',
        'Assessment Type':
          vehicle['description_data']?.['Assessment Type'] || '--',
        'Body Type': vehicle['description_data']?.['Body Type'] || '--',
        COD: vehicle['description_data']?.['COD'] || '--',
        Condition: vehicle['description_data']?.['Condition'] || '--',
        Cylinders: vehicle['description_data']?.['Cylinders'] || '--',
        Doors: vehicle['description_data']?.['Doors'] || '--',
        'Drive Type': vehicle['description_data']?.['Drive Type'] || '--',
        'Engine Type': vehicle['description_data']?.['Engine Type'] || '--',
        Estimara: vehicle['description_data']?.['Estimara'] || '--',
        'Estimara expiry date':
          vehicle['description_data']?.['Estimara expiry date'] || '--',
        'Finance Status':
          vehicle['description_data']?.['Finance Status'] || '--',
        'Fuel Type': vehicle['description_data']?.['Fuel Type'] || '--',
        'HP (Horse Power)':
          vehicle['description_data']?.['HP (Horse Power)'] || '--',
        'Last service date':
          vehicle['description_data']?.['Last service date'] || '--',
        'MVPI expiry date':
          vehicle['description_data']?.['MVPI expiry date'] || '--',
        'Max Speed': vehicle['description_data']?.['Max Speed'] || '--',
        Mileage: vehicle['description_data']?.['Mileage'] || '--',
        Origin: vehicle['description_data']?.['Origin'] || '--',
        Seat: vehicle['description_data']?.['Seat'] || '--',
        'Service and maintenance status':
          vehicle['description_data']?.['Service and maintenance status'] ||
          '--',
        Torque: vehicle['description_data']?.['Torque'] || '--',
        'Transmission Type':
          vehicle['description_data']?.['Transmission Type'] || '--',
        Upholstery: vehicle['description_data']?.['Upholstery'] || '--',
        'Utility Type': vehicle['description_data']?.['Utility Type'] || '--',
        'Vehicle Type': vehicle['description_data']?.['Vehicle Type'] || '--',
        Vendor: vehicle['description_data']?.['Vendor'] || '--',
        Warranty: vehicle['description_data']?.['Warranty'] || '--',
        'Warranty expiry date':
          vehicle['description_data']?.['Warranty expiry date'] || '--',
        'Wheel Base': vehicle['description_data']?.['Wheel Base'] || '--',
        View: vehicle['product_id'],
      };
    });
    return preparedData;
  }

  prepareAuctionVehicleTableData(vehicles: object[]) {
    const preparedData = vehicles.map((vehicle) => {
      return {
        Photo: vehicle['vehicle_images']
          ? environment.imgBaseUrl +
            vehicle['vehicle_images']?.['parts_images'].filter(
              (part) => part.part_name === 'Front'
            )?.[0]?.['image']
          : environment.forntend_url + 'assets/img/car-placeholder.png',
        Make: vehicle['description_data']['Make'],
        Model: vehicle['description_data']['Model'],
        'Trim/Type': vehicle['description_data']['Trim/Type'],
        'Model Year': vehicle['description_data']['Model Year'],
        VIN: vehicle['description_data']['VIN Number'],
        Registration: vehicle['description_data']['Plate Number'],
        ODO: vehicle['description_data']['ODO'],
        'Added In': vehicle?.['inventory_location'] || '--',
        'Exterior Colour': vehicle['description_data']['Exterior Colour'],
        'Interior Colour': vehicle['description_data']['Interior Colour'],
        'Engine CC': vehicle['description_data']['CC'],
        Gears: vehicle['description_data']?.['Gear'] || '--',
        Accleration: vehicle['description_data']?.['Accleration'] || '--',
        'Assessment Type':
          vehicle['description_data']?.['Assessment Type'] || '--',
        'Body Type': vehicle['description_data']?.['Body Type'] || '--',
        COD: vehicle['description_data']?.['COD'] || '--',
        Condition: vehicle['description_data']?.['Condition'] || '--',
        Cylinders: vehicle['description_data']?.['Cylinders'] || '--',
        Doors: vehicle['description_data']?.['Doors'] || '--',
        'Drive Type': vehicle['description_data']?.['Drive Type'] || '--',
        'Engine Type': vehicle['description_data']?.['Engine Type'] || '--',
        Estimara: vehicle['description_data']?.['Estimara'] || '--',
        'Estimara expiry date':
          vehicle['description_data']?.['Estimara expiry date'] || '--',
        'Finance Status':
          vehicle['description_data']?.['Finance Status'] || '--',
        'Fuel Type': vehicle['description_data']?.['Fuel Type'] || '--',
        'HP (Horse Power)':
          vehicle['description_data']?.['HP (Horse Power)'] || '--',
        'Last service date':
          vehicle['description_data']?.['Last service date'] || '--',
        'MVPI expiry date':
          vehicle['description_data']?.['MVPI expiry date'] || '--',
        'Max Speed': vehicle['description_data']?.['Max Speed'] || '--',
        Mileage: vehicle['description_data']?.['Mileage'] || '--',
        Origin: vehicle['description_data']?.['Origin'] || '--',
        Seat: vehicle['description_data']?.['Seat'] || '--',
        'Service and maintenance status':
          vehicle['description_data']?.['Service and maintenance status'] ||
          '--',
        Torque: vehicle['description_data']?.['Torque'] || '--',
        'Transmission Type':
          vehicle['description_data']?.['Transmission Type'] || '--',
        Upholstery: vehicle['description_data']?.['Upholstery'] || '--',
        'Utility Type': vehicle['description_data']?.['Utility Type'] || '--',
        'Vehicle Type': vehicle['description_data']?.['Vehicle Type'] || '--',
        Vendor: vehicle['description_data']?.['Vendor'] || '--',
        Warranty: vehicle['description_data']?.['Warranty'] || '--',
        'Warranty expiry date':
          vehicle['description_data']?.['Warranty expiry date'] || '--',
        'Wheel Base': vehicle['description_data']?.['Wheel Base'] || '--',
        Location: vehicle?.['location'] || '--',
        // Actions: vehicle['product_id'],
        Actions: {
          productId: vehicle['product_id'],

          productName: `${vehicle['description_data']['Model Year']} ${vehicle?.['description_data']?.['Make']} ${vehicle?.['description_data']?.['Model']} ${vehicle?.['description_data']?.['Trim/Type']}`,
          addedIn: vehicle?.['inventory_location'],
          status: vehicle?.['play_status'],
        },
      };
    });
    return preparedData;
  }

  prepareBatchTableData(batches: object[]) {
    const preparedData = batches.map((batch) => {
      return {
        Photo: batch?.['batchImageUrl']?.[0]?.['presigned_url'] || '--',
        'Batch id': batch['id'],
        'Batch name': batch?.['group_name'] || '--',
        Location: batch?.['location'] || '--',
        'Number of vehicles': batch?.['totalNoOfVehicles'] || '--',
        Action: batch['product_group_id'],
      };
    });

    return preparedData;
  }

  prepareSoldBulkTableData(allAuctions: object[]) {
    const preparedData = allAuctions
      ?.filter((bulkAuctions) => bulkAuctions['entity_type'] === 'group')
      ?.map((bulkAuction) => {
        return {
          Photo:
            bulkAuction?.['bulkInfo']?.[0]?.['BatchImageUrl']?.[0]?.[
              'presigned_url'
            ] || environment.forntend_url + 'assets/img/car-placeholder.png',
          Title: bulkAuction?.['title'] || '--',
          'Total number of vehicles':
            bulkAuction?.['bulkInfo']?.['0']?.['ProductInfo']?.length,
          'Opening price': bulkAuction?.['opening_price'] || '--',
          'Reserved price': bulkAuction?.['lowest_price'] || '--',
          'Buy now price': bulkAuction?.['buy_now_price'] || '--',
          'Recycle times': bulkAuction?.['recycle'] || '--',
          Location: bulkAuction?.['bulkInfo']?.[0]?.['location'] || '--',
          Action: bulkAuction?.['bulkInfo']?.[0]?.['product_group_id'],
        };
      });

    return preparedData;
  }

  prepareSoldIndividualTableData(allAuctions: object[]) {
    let preparedData;
    console.log(allAuctions, 'prepareSoldIndividualTableData');
    try {
      preparedData = allAuctions?.map((individualAuction) => {
        return {
          Photo: individualAuction['vehicle_images']
            ? environment.imgBaseUrl +
              individualAuction['vehicle_images']?.['parts_images'].filter(
                (part) => part.part_name === 'Front'
              )?.[0]?.['image']
            : environment.forntend_url + 'assets/img/car-placeholder.png',

          Make: individualAuction['description_data']['Make'],
          Model: individualAuction['description_data']['Model'],
          'Trim/Type': individualAuction['description_data']['Trim/Type'],
          'Model Year': individualAuction['description_data']['Model Year'],
          VIN: individualAuction['description_data']['VIN Number'],
          Registration: individualAuction['description_data']['Plate Number'],
          ODO: individualAuction['description_data']['ODO'],
          // 'Auction Type': individualAuction['entity_type'],

          'Exterior Colour':
            individualAuction['description_data']['Exterior Colour'],
          'Interior Colour':
            individualAuction['description_data']['Interior Colour'],
          'Engine CC': individualAuction['description_data']['CC'],
          Gears: individualAuction['description_data']?.['Gear'] || '--',

          'Reserved Price': individualAuction?.['lowest_price'] || '--',
          'Buy now Price': individualAuction?.['buy_now_price'] || '--',

          Accleration:
            individualAuction['description_data']?.['Accleration'] || '--',
          'Assessment Type':
            individualAuction['description_data']?.['Assessment Type'] || '--',
          'Body Type':
            individualAuction['description_data']?.['Body Type'] || '--',
          COD: individualAuction['description_data']?.['COD'] || '--',
          Condition:
            individualAuction['description_data']?.['Condition'] || '--',
          Cylinders:
            individualAuction['description_data']?.['Cylinders'] || '--',
          Doors: individualAuction['description_data']?.['Doors'] || '--',
          'Drive Type':
            individualAuction['description_data']?.['Drive Type'] || '--',
          'Engine Type':
            individualAuction['description_data']?.['Engine Type'] || '--',
          Estimara: individualAuction['description_data']?.['Estimara'] || '--',
          'Estimara expiry date':
            individualAuction['description_data']?.['Estimara expiry date'] ||
            '--',
          'Finance Status':
            individualAuction['description_data']?.['Finance Status'] || '--',
          'Fuel Type':
            individualAuction['description_data']?.['Fuel Type'] || '--',
          'HP (Horse Power)':
            individualAuction['description_data']?.['HP (Horse Power)'] || '--',
          'Last service date':
            individualAuction['description_data']?.['Last service date'] ||
            '--',
          'MVPI expiry date':
            individualAuction['description_data']?.['MVPI expiry date'] || '--',
          'Max Speed':
            individualAuction['description_data']?.['Max Speed'] || '--',
          Mileage: individualAuction['description_data']?.['Mileage'] || '--',
          Origin: individualAuction['description_data']?.['Origin'] || '--',
          Seat: individualAuction['description_data']?.['Seat'] || '--',
          'Service and maintenance status':
            individualAuction['description_data']?.[
              'Service and maintenance status'
            ] || '--',
          Torque: individualAuction['description_data']?.['Torque'] || '--',
          'Transmission Type':
            individualAuction['description_data']?.['Transmission Type'] ||
            '--',
          Upholstery:
            individualAuction['description_data']?.['Upholstery'] || '--',
          'Utility Type':
            individualAuction['description_data']?.['Utility Type'] || '--',
          'Vehicle Type':
            individualAuction['description_data']?.['Vehicle Type'] || '--',
          Vendor: individualAuction['description_data']?.['Vendor'] || '--',
          Warranty: individualAuction['description_data']?.['Warranty'] || '--',
          'Warranty expiry date':
            individualAuction['description_data']?.['Warranty expiry date'] ||
            '--',
          'Wheel Base':
            individualAuction['description_data']?.['Wheel Base'] || '--',
          Location: individualAuction?.['bulkInfo']?.[0]?.['location'] || '--',
          Action: individualAuction['product_id'],
        };
      });
    } catch (err) {
      console.log(err, 'error prepareSoldIndividualTableData');
    }

    return preparedData;
  }

  prepareBulkVehicles(vehicles: object[]) {
    const preparedData = vehicles.map((vehicle) => {
      return {
        Photo: vehicle['vehicle_images']
          ? environment.imgBaseUrl +
            vehicle['vehicle_images']?.['parts_images'].filter(
              (part) => part.part_name === 'Front'
            )?.[0]?.['image']
          : environment.forntend_url + 'assets/img/car-placeholder.png',

        Make: vehicle['description_data']['Make'],
        Model: vehicle['description_data']['Model'],
        'Trim/Type': vehicle['description_data']['Trim/Type'],
        'Model Year': vehicle['description_data']['Model Year'],
        VIN: vehicle['description_data']['VIN Number'],
        Registration: vehicle['description_data']['Plate Number'],
        ODO: vehicle['description_data']['ODO'],
        'Exterior Colour': vehicle['description_data']['Exterior Colour'],
        'Interior Colour': vehicle['description_data']['Interior Colour'],
        'Engine CC': vehicle['description_data']['CC'],
        Gears: vehicle['description_data']?.['Gear'] || '--',
        Accleration: vehicle['description_data']?.['Accleration'] || '--',
        'Assessment Type':
          vehicle['description_data']?.['Assessment Type'] || '--',
        'Body Type': vehicle['description_data']?.['Body Type'] || '--',
        COD: vehicle['description_data']?.['COD'] || '--',
        Condition: vehicle['description_data']?.['Condition'] || '--',
        Cylinders: vehicle['description_data']?.['Cylinders'] || '--',
        Doors: vehicle['description_data']?.['Doors'] || '--',
        'Drive Type': vehicle['description_data']?.['Drive Type'] || '--',
        'Engine Type': vehicle['description_data']?.['Engine Type'] || '--',
        Estimara: vehicle['description_data']?.['Estimara'] || '--',
        'Estimara expiry date':
          vehicle['description_data']?.['Estimara expiry date'] || '--',
        'Finance Status':
          vehicle['description_data']?.['Finance Status'] || '--',
        'Fuel Type': vehicle['description_data']?.['Fuel Type'] || '--',
        'HP (Horse Power)':
          vehicle['description_data']?.['HP (Horse Power)'] || '--',
        'Last service date':
          vehicle['description_data']?.['Last service date'] || '--',
        'MVPI expiry date':
          vehicle['description_data']?.['MVPI expiry date'] || '--',
        'Max Speed': vehicle['description_data']?.['Max Speed'] || '--',
        Mileage: vehicle['description_data']?.['Mileage'] || '--',
        Origin: vehicle['description_data']?.['Origin'] || '--',
        Seat: vehicle['description_data']?.['Seat'] || '--',
        'Service and maintenance status':
          vehicle['description_data']?.['Service and maintenance status'] ||
          '--',
        Torque: vehicle['description_data']?.['Torque'] || '--',
        'Transmission Type':
          vehicle['description_data']?.['Transmission Type'] || '--',
        Upholstery: vehicle['description_data']?.['Upholstery'] || '--',
        'Utility Type': vehicle['description_data']?.['Utility Type'] || '--',
        'Vehicle Type': vehicle['description_data']?.['Vehicle Type'] || '--',
        Vendor: vehicle['description_data']?.['Vendor'] || '--',
        Warranty: vehicle['description_data']?.['Warranty'] || '--',
        'Warranty expiry date':
          vehicle['description_data']?.['Warranty expiry date'] || '--',
        'Wheel Base': vehicle['description_data']?.['Wheel Base'] || '--',
        View: vehicle['product_id'],
      };
    });
    return preparedData;
  }

  preparePurchaseTableData(purchases: object[]) {
    const preparedData = purchases?.map((purchase, index) => {
      return {
        'SL No': index + 1,
        VIN: purchase?.['vin_number'] || '--',
        Client: `${purchase?.['title']} ${purchase?.['first_name']} ${purchase?.['last_name']}`,
        'Vehicle Name': purchase?.['vehicle_name'] || '--',
        Phone: purchase?.['contact_number'] || '--',
        'Payment Method': paymentType[purchase?.['payment_order_type']] || '--',
        Status: this.calculateStatus(
          purchase['payment_order_type_status'],
          purchase['buy_status']
        ),
        'Delivery Date': purchase?.['order_date']?.slice(0, 10),
        View: purchase['payment_uuid'],
      };
    });

    return preparedData;
  }

  calculateStatus(orderType: boolean | null, buyStatus: '0' | '1' | '2') {
    let status: string;

    if (orderType === null && buyStatus === '0') {
      status = 'Pending';
    } else if (orderType === false && buyStatus === '0') {
      status = 'Unreserve';
    } else if (orderType && buyStatus === '0') {
      status = 'Reserve';
    } else if (orderType && buyStatus === '1') {
      status = 'Sold';
    } else if (orderType && buyStatus === '2') {
      status = 'Sold';
    } else {
      status = '--';
    }

    return status;
  }
}
